"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

var _H = _interopRequireDefault(require("../H3"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stat = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "Stat",
  componentId: "sc-10ijpvr-0"
})(["margin:0 auto;color:", ";"], function (p) {
  return p.na ? (0, _helpers.color)('dark-1') : (0, _helpers.color)('white');
});

var Component = function Component(_ref) {
  var className = _ref.className,
      _ref$score = _ref.score,
      score = _ref$score === void 0 ? 0 : _ref$score,
      _ref$na = _ref.na,
      na = _ref$na === void 0 ? false : _ref$na;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(Stat, {
    score: score,
    na: na
  }, na ? 'N/A' : "".concat(Math.floor(score), "%")));
};

var Statistic = (0, _styledComponents.default)(Component).withConfig({
  displayName: "Statistic",
  componentId: "sc-10ijpvr-1"
})(["align-items:center;background-color:", ";border-radius:4px;display:flex;height:40px;margin-right:16px;padding:4px 8px;width:4rem;"], function (p) {
  return p.na ? (0, _helpers.color)('statusUnknown') : (0, _helpers.scoreToBgColor)(p.score);
});
var _default = Statistic;
exports.default = _default;